

































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {Comment, Task} from '@/store/types'
import VueMention from '@/components/common/packages/VueMention.vue'
import _ from 'lodash'

@Component({
  components: {
    VueMention,
  },
})
export default class TaskComments extends Vue {
  @Getter('comments') public comments!: Comment[]
  @Getter('task') public task!: Task
  @Getter('users') public users!: any[]
  @Action('addComment') public addComment!: any

  public disabledButton: boolean = false
  public commentInput: string = ''

  public get options() {
    return {
      values: this.users,
      lookup: 'full_name',
      fillAttr: 'username',
    }
  }

  public getCommentedUserIDs() {
    let mentions = this.commentInput.match(/([@])([a-zA-Z0-9-_.])+/g)
    if (mentions === null) {
      mentions = []
    }
    mentions = mentions.map((m) => {
      const username = m.replace('@', '')
      const user = this.users.find((u) => u.username === username)
      if (user !== undefined) {
        return user.id
      }
    }).filter((u) => u !== undefined)
    return _.uniq(mentions)
  }

  public addNewComment() {
    this.disabledButton = true
    const mentions = this.getCommentedUserIDs()
    const data = {
      content: this.commentInput,
      commentable_id: this.task.id,
      commentable_type: 'survey',
      mentions,
    }
    this.addComment(Object.assign({}, data)).then((response: any) => {
      this.commentInput = ''
      this.disabledButton = false
    })
  }
  public parseComment(comment: string) {
    return comment.replace(/([@])([a-zA-Z0-9-_.])+/g, (text) => {
      return `<span class="text-primary">${text}</span>`
    })
  }
  public replaceTribute() {
    const comment = document.getElementById('commentInput') as HTMLInputElement
    this.commentInput = comment.value
  }
}
